import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  // simple function which expects a parameter `url` and will replace the `src`
  // attribute on the element having the event listener installed on with the one
  // passed into via the parameter `url`
  //
  // if the `replace` function is called again, it will open the URL in a new window,
  // so to stop this, use the `:once` attribute on the `action`
  async replace(event) {
    const target = event.currentTarget;
    const url = event.params.url;
    const targetUrl = new URL(target.src).pathname;

    if (targetUrl && url && targetUrl !== url) {
      // make it a placeholder
      target.classList.add('placeholder', 'placeholder-img');
      // fake image to preload it
      // see: https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/decode
      const img = new Image();
      img.src = url;
      await img.decode();

      target.src = url;
      target.classList.remove('placeholder', 'placeholder-img');
    } else if (targetUrl && url && targetUrl === url) {
      window.open(url, "_blank");
    }
  }
}
